import {
  doesNotExceedMaxConsecutiveChars,
  hasLowerCase,
  hasNumber,
  hasSpecialChar,
  hasUpperCase,
  isMinLength
} from './helpers'

export const PASSWORD_MIN_LENGTH = 12
export const PASSWORD_MAX_CONSECUTIVE_CHARS = 2

/*
Custom password validator to be used with Mantine form validation.

Checks the password according to the following rules:
- min. 12 characters
- at least one lowercase letter
- at least one uppercase letter
- at least one number
- at least one special character
- no more than 2 consecutive identical characters

Returns null if password is valid, otherwise returns an error message.
*/
export const isStrongPassword = (message: string) => {
  return function (value: string) {
    if (
      isMinLength(value, PASSWORD_MIN_LENGTH) &&
      hasLowerCase(value) &&
      hasUpperCase(value) &&
      hasNumber(value) &&
      hasSpecialChar(value) &&
      doesNotExceedMaxConsecutiveChars(value, PASSWORD_MAX_CONSECUTIVE_CHARS)
    ) {
      return null
    }

    return message
  }
}
